import * as PIXI from "pixi.js";
import { NavigationLandscapeProperties } from "../landscape/NavigationLandscapeProperties";
/**
 * NavigationPortraitProperties.ts
 */
export class NavigationPortraitProperties extends NavigationLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties.position = new PIXI.Point(512, 0);
        this.fieldOffset = 65;
    }
}
